import { html } from "lit";
import { t } from "../../i18n/index.ts";
import type { AppViewState } from "../app-view-state.ts";
import { icons } from "../icons.ts";
import { normalizeBasePath } from "../navigation.ts";
import { agentLogoUrl } from "./agents-utils.ts";

export function renderLoginGate(state: AppViewState) {
  const loginMode = "user";
  const basePath = normalizeBasePath(state.basePath ?? "");
  const faviconSrc = agentLogoUrl(basePath);

  return html`
    <div class="login-gate">
      <div class="login-gate__card">
        <div class="login-gate__header">
          <img
            class="login-gate__logo"
            src=${faviconSrc}
            alt="OpenClaw"
            @dblclick=${() => {
              state.loginShowGatewayUrl = !state.loginShowGatewayUrl;
            }}
          />
          <div class="login-gate__title">OpenClaw</div>
          <div class="login-gate__sub">${t("login.subtitle")}</div>
        </div>
        <div class="login-gate__form">
          ${state.loginShowGatewayUrl
            ? html`<label class="field">
                <span>${t("overview.access.wsUrl")}</span>
                <input
                  .value=${state.settings.gatewayUrl}
                  @input=${(e: Event) => {
                    const v = (e.target as HTMLInputElement).value;
                    state.applySettings({ ...state.settings, gatewayUrl: v });
                  }}
                  placeholder="ws://127.0.0.1:18789"
                />
              </label>`
            : ""}
          ${loginMode === "user"
            ? html`
                <label class="field">
                  <span>Email</span>
                  <input
                    .value=${state.loginEmail ?? ""}
                    @input=${(e: Event) => {
                      state.loginEmail = (e.target as HTMLInputElement).value;
                    }}
                    placeholder="user@example.com"
                  />
                </label>
                <label class="field">
                  <span>${t("overview.access.password")}</span>
                  <div class="login-gate__secret-row">
                    <input
                      type=${state.loginShowGatewayPassword ? "text" : "password"}
                      autocomplete="off"
                      spellcheck="false"
                      .value=${state.password}
                      @input=${(e: Event) => {
                        state.password = (e.target as HTMLInputElement).value;
                      }}
                      placeholder="${t("login.passwordPlaceholder")}"
                      @keydown=${(e: KeyboardEvent) => {
                        if (e.key === "Enter") {
                          state.connect();
                        }
                      }}
                    />
                    <button
                      type="button"
                      class="btn btn--icon ${state.loginShowGatewayPassword ? "active" : ""}"
                      title=${state.loginShowGatewayPassword
                        ? t("login.hidePassword")
                        : t("login.showPassword")}
                      aria-label=${t("login.togglePasswordVisibility")}
                      aria-pressed=${state.loginShowGatewayPassword}
                      @click=${() => {
                        state.loginShowGatewayPassword = !state.loginShowGatewayPassword;
                      }}
                    >
                      ${state.loginShowGatewayPassword ? icons.eye : icons.eyeOff}
                    </button>
                  </div>
                </label>
              `
            : ""}
          <button class="btn primary login-gate__connect" @click=${() => state.connect()}>
            ${t("common.connect")}
          </button>
        </div>
        ${state.lastError
          ? html`<div class="callout danger" style="margin-top: 14px;">
              <div>${state.lastError}</div>
            </div>`
          : ""}
      </div>
    </div>
  `;
}
